/* eslint-disable */
import React, { Component, Fragment, lazy } from 'react';
import { connect } from 'react-redux';
import { routehelp } from '../../Routehelper';
import { uommanagementlist, orderCatalogue_create, orderCatalogue_get, orderCatalogue_update, productsingle } from '../../actions';
import { validate, errorRender, successRedriect, getValue, getCompanyId } from '../../helpers/functions';
import 'reactjs-toastr/lib/toast.css';
import InputNumberField from '../../components/inputnumberfields';
require('react-datetime');

const ProductDropdown = lazy(() => import('../productManagement/productDropdown'));
const SelectInputField = lazy(() => import('../../components/selectInputField'));
const SingleBrandDropDown = lazy(() => import('../../container/brandsManagement/singleBrandDropDown'));

const Links = lazy(() => import('../../components/links'));
const Buttons = lazy(() => import('../../components/buttons'));
const TextAreaInputField = lazy(() => import('../../components/textAreaInputField'));
const Inputfield = lazy(() => import('../../components/inputfields'));
const Loader = lazy(() => import('../../components/loader'));

class OrderCatalogueForm extends Component {
    constructor(props) {
        super(props);

        this.initDefaultItems = () => ({
            productId: "",
            shadeId: "",
            product: "",
            productErpCode: "",
            productName: "",
            productPrice: "",
            retailerPrice: "",
            subTotal: "",
            netPrice: "",
            subTotalQuantity: "1",
            attributes: {
                convFact: "",
                name: "",
                description: "",
                code: "",
                quantity: "",
                shadeQuantity: "",
                quantityUnit: "",
                price: "",
                isQuantity: "",
                subtotalShade: "1",
                unitCode: {
                    unitName: "taka",
                    unitCode: "",
                    shade: "",
                    convFact: "13"
                }
            },

            // Extra parameters which is not need to added in items
            productError: '',
            shadeOptions: []
        })

        this.state = {
            pageType: 'add',
            name: "",
            brand: "",
            note: "",
            numItems: 2,
            dynamicRows: [],
            groups: [],
            isFixedItems: false,
            nameError: "",
            numItemsError: "",
            alertMessage: "",
            serverErrors: ["orderCatalogue_create_res", "orderCatalogue_update_res"],
            forRedirect: [
                { name: "orderCatalogue_create_res", pageName: 'Order Catalogue', pageUrl: 'orderCatalogueList', action: "create" },
                { name: "orderCatalogue_update_res", pageName: 'Order Catalogue', pageUrl: 'orderCatalogueList', action: "update" }
            ],
            setFields: [
                { name: "name", type: "text" },
                { name: "brand", type: "select" },
                { name: "numItems", type: "text" },
                { name: "totalQuantity", type: "text" },
                { name: "totalAmount", type: "text" },
                { name: "note", type: "text" },
                { name: "groups", type: "array" }
            ],

            uomDisplay: {},
            isMultiple: false,
            brandError: "",
            shadeDesc: {},
            product: "",
            products: [],
            productError: "",
            uom: [{
                label: "Please select UOM",
                value: "",
                code: "",
                conFact: ""
            }],
            shade: [],
            totalAmount: 0,
            price: 0,
            uom_data: "",
            isLoading: false,
            getSingleLoader: false,
            filterProduct: {},
            uomError: "",
            unitCodes: [],
            multiplier: 1,
            subTotal: 0,
            multipleProducts: [],
            productTotal: 0,
            price: 0,
            productDetails: [],
        }
    };

    componentDidMount() {
        this.loadResult();
    };

    loadResult = () => {
        this.props.uommanagementlist({});
        let id = this.props.match.params.item_id;
        if (id) {
            this.setState({ pageType: "update", itemId: id, getSingleLoader: true })
            this.props.orderCatalogue_get(id);
        }
        // this.setState({ isLoading: true });
    };

    componentWillUnmount() {
        this.setState({});
    };


    dropdownValueChange = (value, name) => {
        // console.log(name, value);
        if (name === "brand") {
            this.setState({
                [name]: value,
                product: null,
                uom: [{
                    label: "Please select UOM",
                    value: "",
                    code: "",
                    conFact: ""
                }],
                shade: [],
                uom_data: "",
                totalAmount: 0,
                totalQuantity: 0,
                productTotal: 0,
                subTotal: 0,
                price: 0,
                filterProduct: {
                    brand: value.value
                },
                multiplier: value.multiplier
            });
        } else {
            this.setState({ [name]: value });
        }
    };

    setFixedNumberOfItems = () => {
        if (this.state.numItems >= 2 && this.state.numItems <= 5) {
            const numericValue = parseInt(this.state.numItems, 10);
            this.setState({
                isFixedItems: true,
                dynamicRows: Array.from({ length: numericValue }, this.initDefaultItems),
                alertMessage: ''
            })
        } else {
            this.setState({
                alertMessage: "Please select number of item between 2-5 only for catelogue"
            });
        }
    }

    rawValueChange = (e, fieldName, index) => {
        const value = e.target ? e.target.value : e;

        this.setState(prevState => {
            const newDynamicRows = [...prevState.dynamicRows];
            const currentRow = { ...newDynamicRows[index] };

            currentRow[fieldName] = value;
            if (fieldName === 'productId' && value) {
                // currentRow.uom = this.fetchUOMsForProduct(value);

                currentRow.shadeOptions = [{
                    value: '', label: 'Select Shade'
                }].concat(value.items.attributes.map(ele => {
                    const rawData = { ...ele };
                    rawData.value = ele.name;
                    rawData.label = ele.name;
                    return rawData;
                }));

                // Product details filled.
                currentRow.product = value.value;
                currentRow.productName = value.label;
                currentRow.productPrice = value.items.price;
                currentRow.productErpCode = "";
                currentRow.retailerPrice = "";
                currentRow.subTotal = "";
                currentRow.netPrice = value.items.price;
                currentRow.subTotalQuantity = "";

                // Attributes details set blank
                currentRow.shadeId = "";
                currentRow.attributes = {
                    name: "",
                    unitCode: {}
                };
            } else if (fieldName == 'shadeId') {
                currentRow.shadeId = value;
                currentRow.attributes = {
                    name: "",
                    unitCode: {}
                };

                if (value) {
                    const filtered = currentRow.shadeOptions.find(e => e.name == value);
                    if (filtered) {
                        currentRow.attributes = { ...filtered };
                        currentRow.attributes.unitCode = { ...filtered.unitCodes.find(e => e.unitName == 'taka') || {} };

                        currentRow.attributes.convFact = currentRow.attributes.unitCode.convFact;
                        currentRow.attributes.quantity = "1";
                        currentRow.attributes.shadeQuantity = "1";
                        currentRow.attributes.quantityUnit = 'taka';
                        currentRow.attributes.unitCode.shade = value;
                        delete currentRow.attributes.unitCodes;
                    }
                }
            }

            if (fieldName === 'productId') currentRow.productError = value ? '' : 'Product is required';

            newDynamicRows[index] = currentRow;
            return { dynamicRows: newDynamicRows };
        });
    };

    addMoreItem = () => {
        // Perform final validation on all dynamic rows
        const isValidProducts = this.state.dynamicRows.every(row => row.product);
        const isValidShade = this.state.dynamicRows.some(row => row.attributes && row.attributes.name);
        if (!isValidProducts) {
            this.setState({ alertMessage: "Please ensure all product fields are filled for each item." });
            return false;
        }

        if (!isValidShade) {
            this.setState({ alertMessage: "Please ensure atleast one shade is filled." });
            return false;
        }

        console.log("Submitting dynamic items:", this.state.dynamicRows);
        // Proceed with your submission logic
        this.setState(prevState => {
            const newGroups = prevState.groups;
            newGroups.push({
                items: prevState.dynamicRows
            })

            return { groups: newGroups, alertMessage: '' };
        }, () => {
            this.countFinalTotal();
        })
    };

    countFinalTotal = () => {
        let total = 0, quantity = 0;
        if (this.state.groups && this.state.groups.length > 0) {
            this.state.groups.forEach((ele) => {
                ele.items.forEach(item => {
                    quantity += parseFloat(item.attributes.quantity || 0);
                    total += parseFloat(item.attributes.convFact || 1) * parseFloat(item.attributes.quantity || 1) * parseFloat(item.productPrice);
                })
            });
        }
        this.setState({
            totalAmount: total,
            totalQuantity: quantity,
            dynamicRows: Array.from({ length: this.state.numItems }, this.initDefaultItems),
        });
    }


    callFinalJson = () => {
        const data = {
            name: this.state.name || null,
            numItems: this.state.numItems || null,
            brand: this.state.brand && this.state.brand.value ? this.state.brand.value : undefined,
            totalQuantity: this.state.totalQuantity,
            totalAmount: parseFloat(this.state.totalAmount).toFixed(2),
            note: this.state.note,
            groups: this.state.groups,
            company: getCompanyId(localStorage.getItem('type')),
        }
        return data;
    };

    onsubmit = (e) => {
        let valid = this.callCheckValidations();

        if (valid) {
            if (this.state.groups.length == 0) {
                this.setState({ alertMessage: "Please add any one groups to create/update order Catalogue." });
                return false;
            }

            const data = this.callFinalJson();
            this.callApi(data, e);
        }
    };

    checkIfArrayIsUnique = (myArray) => {
        for (var i = 0; i < myArray.length; i++) {
            for (var j = 0; j < myArray.length; j++) {
                if (i !== j) {
                    if (myArray[i].name === myArray[j].name && myArray[i].uom === myArray[j].uom) {
                        return true; // means there are duplicate values
                    }
                }
            }
        }
        return false; // means there are no duplicate values.
    };

    shouldComponentUpdate(nextProps) {
        // console.log(nextProps);

        if (nextProps !== this.props) {
            if (this.state.isLoading) {
                this.setState({ isLoading: false });
            }
            this.setState({ getSingleLoader: false });
            this.state.serverErrors.forEach((el) => errorRender(nextProps, el));
            this.state.forRedirect.forEach((el) => successRedriect(nextProps, el.name, el.pageName, this.props, el.pageUrl, el.action));

            if (nextProps.uommanagement_res && nextProps.uommanagement_res.count > 0) {
                let displayUOM = {};
                nextProps.uommanagement_res.list.forEach((ele) => {
                    // console.log(ele);
                    displayUOM[ele.code] = ele.name;
                });
                this.setState({
                    uomDisplay: displayUOM
                });
                // console.log(disPlayUOM);
            }

            if (nextProps.orderCatalogue_get_res && nextProps.orderCatalogue_get_res.success) {
                this.setState({
                    isFixedItems: true,
                    getSingleLoader: false,
                    numItems: nextProps.orderCatalogue_get_res.item.numItems,
                    dynamicRows: Array.from({ length: nextProps.orderCatalogue_get_res.item.numItems }, this.initDefaultItems),
                });
                this.state.setFields.forEach((value) => {
                    if (value.type === "text") {
                        this.setState({ [value.name]: getValue(nextProps.orderCatalogue_get_res.item, value.name) })
                    } else if (value.type === "select") {
                        this.setState({
                            [value.name]: {
                                value: getValue(nextProps.orderCatalogue_get_res.item, value.name)._id,
                                label: getValue(nextProps.orderCatalogue_get_res.item, value.name).name
                            }
                        }, () => {
                            if (value.name === "brand") {
                                this.setState({
                                    filterProduct: { brand: getValue(nextProps.orderCatalogue_get_res.item, value.name)._id }
                                });
                            };
                        });
                    } else if (value.type === "array") {
                        if (value.name === "groups") {
                            this.setState({
                                groups: nextProps.orderCatalogue_get_res.item.groups || []
                            });
                        }
                    }
                });
                nextProps.orderCatalogue_get_res.success = null;
            };

            if (nextProps.product_single && nextProps.product_single.success) {
                if (nextProps.product_single.item) {

                    let productDetails = this.state.productDetails || [];
                    if (productDetails && productDetails.length > 0 && productDetails.findIndex((e) => e._id === nextProps.product_single.item._id) !== -1) {
                        let productInd = productDetails.findIndex((e) => e._id === nextProps.product_single.item._id);
                        productDetails[productInd] = nextProps.product_single.item;
                    } else {
                        // console.log(nextProps.product_single.item);
                        productDetails.push(nextProps.product_single.item);
                    };

                    this.setState({
                        productDetails: productDetails
                    }, () => {
                        this.checkingStocks();
                    });

                };
                nextProps.product_single.success = null;
            }

        }

        return true;
    };

    callCheckValidations = () => {
        let validationFields = [
            { name: 'name', label: "Name", value: this.state.name, hasError: false, isRequired: true, isNumber: false, onlyChar: false, maxLength: 500, type: "text", message: "", errName: "nameError" },
            { name: 'numItems', label: "Number Of Items", value: this.state.numItems, hasError: false, isRequired: true, isNumber: true, onlyChar: false, maxLength: 2, type: "text", message: "", errName: "numItemsError" },
            { name: 'brand', label: "Brand", value: this.state.brand, hasError: false, isRequired: true, isNumber: false, onlyChar: false, maxLength: 500, type: "text", message: "", errName: "brandError" }
        ];
        // console.log(validationFields);
        let { newArr, valid } = validate(validationFields);
        newArr.map((el) => this.setState({ [el.errName]: el.message }));
        return valid;
    };

    callApi = (data, e) => {
        e.preventDefault();
        if (data.totalQuantity > 0) {
            if (this.state.pageType === 'add') {
                this.props.orderCatalogue_create(data);
            }
            if (this.state.pageType === 'update') {
                this.props.orderCatalogue_update(data, this.props.match.params.item_id);
            }
        } else if (data.totalQuantity === 0) {
            this.setState({
                alertMessage: "Please save the items to create/update the order Catalogue."
            });
        }
    };

    deleteGroup = (e, index) => {
        e.preventDefault();
        let groups = this.state.groups;
        groups.splice(index, 1);
        this.setState({ groups }, () => {
            this.countFinalTotal();
        });
    };

    handleChange = (name, e) => {
        const re = /([^\s]+)/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ [name]: e.target.value });
        }
    };

    openDesc = (item) => {
        this.setState({
            shadeDesc: item
        });
    };

    render() {
        const { pageType, isLoading, getSingleLoader } = this.state;
        return (
            <main className="main-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 mt-4">
                            <div className="card card-shadow mb-4">

                                <div className="card-header">
                                    <div className="card-title">
                                        {pageType === "update" ? "Update Order Catalogue" : "Add Order Catalogue"}
                                    </div>
                                </div>

                                {
                                    getSingleLoader ? <Loader /> :
                                        <div className="card-body">
                                            <div className="row">

                                                <div className="form-group required col-12 col-lg-4">
                                                    <Inputfield errMessage={this.state.nameError} handleChange={this.handleChange} maxlength="100" type="text" name="name" value={this.state.name} className="form-control" id="name" ariadescribedby="codeHelp" placeholder="Name" />
                                                </div>

                                                <div className="form-group required col-12 col-lg-4">
                                                    <SingleBrandDropDown
                                                        value={this.state.brand}
                                                        ondropdownChange={(e) => this.dropdownValueChange(e, "brand")}
                                                        placeholder="Search Brand"
                                                        errMessage={this.state.brandError}
                                                        disable={this.state.isFixedItems}
                                                    />
                                                </div>

                                                <div className="form-group col-12 col-lg-4">
                                                    <TextAreaInputField
                                                        onChange={(e) => this.dropdownValueChange(e.target.value, "note")}
                                                        type="text"
                                                        name="note"
                                                        maxLength="5000"
                                                        value={this.state.note}
                                                        className="form-control"
                                                        placeholder="Note"
                                                    />
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className="form-group col-12 col-lg-4">
                                                    <InputNumberField
                                                        handleChange={this.handleChange}
                                                        errMessage={this.state.numItemsError}
                                                        type="number"
                                                        name="numItems"
                                                        min="2"
                                                        max="5"
                                                        value={this.state.numItems}
                                                        className="form-control"
                                                        id="numItems"
                                                        aria-describedby="codeHelp"
                                                        placeholder="Number of Items"
                                                        disabled={this.state.isFixedItems || this.state.pageType == 'update'}
                                                    />
                                                </div>
                                                <div className="form-group col-12 col-lg-4 d-flex align-items-end">
                                                    <Buttons onclick={this.setFixedNumberOfItems} type="button" className="btn btn-primary mr-1" disable={this.state.isFixedItems || this.state.pageType == 'update'} loading={isLoading} name="Set Items" />
                                                </div>
                                            </div>

                                            {/* --- Dynamic Rows Section --- */}
                                            {
                                                this.state.isFixedItems && this.state.dynamicRows.map((rowData, index) => (
                                                    <div className='row mb-3 p-3 border rounded shadow-sm bg-light' key={index}> {/* Use index as key (ok for non-reorderable lists) */}
                                                        <h5 className="mb-3">Item {index + 1}</h5>
                                                        <div className="form-group col-12 col-lg-4">
                                                            <label htmlFor={`product-${index}`} className="form-label">Product</label>
                                                            <ProductDropdown
                                                                isLabel={false} // Label is now handled by this component
                                                                ondropdownChange={(e) => this.rawValueChange(e, "productId", index)}
                                                                placeholder="Search Product"
                                                                value={rowData.productId}
                                                                errMessage={rowData.productError}
                                                                dontPreload={this.state.brand ? false : true}
                                                                filterBy={this.state.filterProduct}
                                                                id={`product-${index}`} // Unique ID for each dropdown
                                                            />
                                                        </div>
                                                        <div className="form-group col-12 col-lg-4">
                                                            <label htmlFor={`shade-${index}`} className="form-label">Shade</label>
                                                            <SelectInputField
                                                                isLabel={false} // Label is now handled by this component
                                                                onChange={(e) => this.rawValueChange(e, "shadeId", index)}
                                                                name="shade"
                                                                value={rowData.shadeId}
                                                                className="form-control"
                                                                options={rowData.shadeOptions} // Row-specific UOM options
                                                                id={`shade-${index}`} // Unique ID for each UOM select
                                                            />
                                                        </div>
                                                        {/* You can add more fields per row here, e.g., quantity */}
                                                    </div>
                                                ))
                                            }
                                            {this.state.isFixedItems &&
                                                <div className="row mt-4 mb-4">
                                                    <div className="col-12 col-lg-4 offset-lg-4 text-center">
                                                        <Buttons
                                                            onclick={this.addMoreItem}
                                                            type="button"
                                                            className="btn btn-primary mr-1"
                                                            loading={isLoading}
                                                            name="Save All Items"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {/* --- End Dynamic Rows Section --- */}

                                            {this.state.alertMessage &&
                                                <div className='row'>
                                                    <div className='col-12'>
                                                        <div className='alert alert-danger  text-center'>
                                                            <span className='mb-0'>{this.state.alertMessage}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            }

                                            {this.state.groups.length > 0 &&
                                                <table className="table table-bordered order-list-data">

                                                    <thead>
                                                        <tr>
                                                            <th className='border-radius-0 p-2' colSpan={this.state.numItems}>Catalogue Items</th>
                                                            <th className='border-radius-0 p-2 text-center'>Remove</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.groups.map((group, idx) => (
                                                            <tr key={idx}>
                                                                {group.items.map((item, idx2) => (
                                                                    <td key={idx + '-' + idx2}>
                                                                        {item.productName} - {item.attributes ? item.attributes.name : ''}
                                                                    </td>
                                                                ))}
                                                                <td className='text-center' key={idx + "delete"}>
                                                                    <button className="btn btn-danger mr-1" title="Delete" onClick={(e) => this.deleteGroup(e, idx)}>
                                                                        <i className="ti ti-trash"></i>
                                                                    </button>
                                                                </td>

                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            }

                                            {/* {this.state.isFixedItems &&
                                                <div className="row  justify-content-end">
                                                    <div className='col-3 mt-5 text-right'>
                                                        <label className="mr-2">Total Amount</label>
                                                        <p className="form-control border border-primary rounded ">{parseFloat(this.state.totalAmount || 0).toFixed(2)}/-</p>
                                                    </div>
                                                </div>
                                            } */}
                                            {/* {console.log(getSingleLoader, isLoading)} */}

                                            <div className="row">
                                                <div className="col-md-6 mb-4 mt-3 offset-md-3 text-center">
                                                    {/* <Buttons onclick={this.addMoreItem} type="button" className="btn btn-success mr-1" disable={isLoading || getSingleLoader} loading={isLoading} name="Add More" /> */}
                                                    <Buttons onclick={this.onsubmit} type="submit" className="btn btn-primary mr-1" disable={isLoading || getSingleLoader} loading={isLoading} name="Save" />
                                                    <Links to={routehelp.orderCatalogueList} className="btn btn-outline-dark" name="Cancel" />
                                                </div>
                                            </div>

                                        </div>
                                }

                                <div
                                    className="modal fade bd-example-modal-lg"
                                    tabIndex="-1"
                                    role="dialog"
                                    aria-labelledby="myLargeModalLabel"
                                    style={{ display: "none" }}
                                    aria-hidden="true">
                                    <div className="modal-dialog modal-lg">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title" id="myLargeModalLabel">
                                                    {"Shade Details"}
                                                </h5>
                                                <button
                                                    type="button"
                                                    className="close"
                                                    data-dismiss="modal"
                                                    aria-label="Close"
                                                >
                                                    <span aria-hidden="true" className='cursor' title='close'>×</span>
                                                </button>
                                            </div>

                                            <div className="modal-body">
                                                <div className="row">

                                                    <table className="table table-bordered dataTable" cellSpacing="0">

                                                        <thead>
                                                            <tr>
                                                                <th>Shade Name</th>
                                                                <th>Shade Code</th>
                                                                <th>Shade Description</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    {this.state.shadeDesc.name}
                                                                </td>
                                                                <td>
                                                                    {this.state.shadeDesc.code}
                                                                </td>
                                                                <td>
                                                                    {this.state.shadeDesc.description}
                                                                </td>
                                                            </tr>
                                                        </tbody>

                                                    </table>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </main >
        )
    };

}

function mapStateToProps(state) {
    return {
        uommanagement_res: state.uommanagement_res,
        orderCatalogue_create_res: state.orderCatalogue_create_res,
        orderCatalogue_update_res: state.orderCatalogue_update_res,
        orderCatalogue_get_res: state.orderCatalogue_get_res,
        product_single: state.product_single
    };
};

const mapDispatchToProps = dispatch => ({
    uommanagementlist: data => dispatch(uommanagementlist(data)),
    orderCatalogue_create: data => dispatch(orderCatalogue_create(data)),
    orderCatalogue_update: (data, item_id) => dispatch(orderCatalogue_update(data, item_id)),
    orderCatalogue_get: item_id => dispatch(orderCatalogue_get(item_id)),
    productsingle: (data) => dispatch(productsingle(data))
});

OrderCatalogueForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(OrderCatalogueForm);

export default OrderCatalogueForm;